import useAuth from '../../auth/UseAuth';
import { useEffect, useState } from 'react';
import { orderBy } from 'lodash';
import { GetPipelines, SuperDuperFiestaPipeline } from '../../data/SuperDuperFiestaData';
import { useUserPermissions } from '../../contexts/UserPermissionContext';

const useSuperDuperFiestaPipelines = (): ReadonlyArray<SuperDuperFiestaPipeline> => {
  const { accessToken } = useAuth();
  const { hasSuperDuperFiestaAccess } = useUserPermissions();
  const [SuperDuperFiestaPipelines, setSuperDuperFiestaPipelines] = useState<ReadonlyArray<SuperDuperFiestaPipeline>>(
    []
  );

  useEffect(() => {
    if (!accessToken || !hasSuperDuperFiestaAccess) {
      return;
    }

    let isCancelled = false;

    GetPipelines(accessToken).then(data => {
      if (isCancelled) {
        return;
      }

      setSuperDuperFiestaPipelines(orderBy(data, i => i.name));
    });

    return () => {
      isCancelled = true;
    };
  }, [accessToken, hasSuperDuperFiestaAccess]);

  return SuperDuperFiestaPipelines;
};

export default useSuperDuperFiestaPipelines;
